import { cva, type VariantProps } from 'class-variance-authority';

export const surfaceVariants = cva(
  'bg-background/50 rounded-2xl border border-white backdrop-blur-2xl p-4',
);

export type SurfaceVariants = VariantProps<typeof surfaceVariants>;
